exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".insert-role[data-v-7590fb61] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.form-check-input[data-v-7590fb61],\n.form-check-label[data-v-7590fb61] {\n  cursor: pointer;\n}\n", ""]);

// exports
